/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfTrendingSearchListedAdminDto } from '../models/Pagination1OfTrendingSearchListedAdminDto';
import type { Pagination1OfTrendingSearchListedClientDto } from '../models/Pagination1OfTrendingSearchListedClientDto';
import type { PostPutTrendingSearchAdminRequest } from '../models/PostPutTrendingSearchAdminRequest';
import type { TrendingSearchAdminDto } from '../models/TrendingSearchAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TrendingSearchesService {
    /**
     * @returns Pagination1OfTrendingSearchListedClientDto OK
     * @throws ApiError
     */
    public static getTrendingSearchesClient({
        channelId,
        page,
        limit,
    }: {
        channelId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfTrendingSearchListedClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/trendingsearches',
            query: {
                'channelId': channelId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewTrendingSearches`
     * @returns Pagination1OfTrendingSearchListedAdminDto OK
     * @throws ApiError
     */
    public static getTrendingSearchesAdmin({
        searchWord,
        channelId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        channelId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfTrendingSearchListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/trendingsearches',
            query: {
                'searchWord': searchWord,
                'channelId': channelId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageTrendingSearch`
     * @returns TrendingSearchAdminDto Created
     * @throws ApiError
     */
    public static createTrendingSearchAdmin({
        requestBody,
    }: {
        requestBody?: PostPutTrendingSearchAdminRequest,
    }): CancelablePromise<TrendingSearchAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/trendingsearches',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewTrendingSearchDetails`
     * @returns TrendingSearchAdminDto OK
     * @throws ApiError
     */
    public static getTrendingSearchByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<TrendingSearchAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/trendingsearches/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageTrendingSearch`
     * @returns TrendingSearchAdminDto OK
     * @throws ApiError
     */
    public static updateTrendingSearchAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutTrendingSearchAdminRequest,
    }): CancelablePromise<TrendingSearchAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/trendingsearches/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteTrendingSearch`
     * @returns void
     * @throws ApiError
     */
    public static deleteTrendingSearchAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/trendingsearches/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
